<template>
    <ASelect
        mode="multiple"
        v-model:value="valueState"
        placeholder="Pilih Customer"
        allow-clear
        show-search
        :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (state.params.q = '')"
        v-bind="$attrs"
        :filter-option="false"
        :loading="state.loading"
        :show-arrow="true"
        :disabled="!props.distributor"> <!-- ✅ disable jika belum pilih distributor -->
        <ASelectOption v-for="d in state.data" :key="d.id" :label="d.name">
            <span v-html="highlight(d.name)"></span>
        </ASelectOption>
        <template v-if="state.loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </ASelect>
</template>

<script>
import { reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, pickBy } from 'lodash'

export default {
    props: {
        value: {
            default: () => [],
            type: Array,
        },
        distributor: {
            type: [String, Number],
            default: null,
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: '/api/filter/toko-curah-by-distributor',
            loading: false,
            data: [],
            params: {
                q: '',
                distributor: props.distributor,
            },
        })

        const fetchData = () => {
            if (!state.params.distributor) {
                state.data = [] // ✅ kosongkan jika belum pilih distributor
                return
            }
            state.loading = true
            apiClient
                .get(state.endpoint, { params: pickBy(state.params) })
                .then(({ data }) => {
                    state.data = data
                })
                .finally(() => {
                    state.loading = false
                })
        }

        // ✅ refetch otomatis saat distributor berubah
        watch(() => props.distributor, (val) => {
            state.params.distributor = val
            state.data = [] // reset data customer saat ganti distributor
            fetchData()
        })

        watch(() => state.params.q, debounce(() => {
            fetchData()
        }, 300))

        const onSearch = (value) => {
            state.params.q = value
        }

        const highlight = (value) => {
            if (!state.params.q) return value
            return value.replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        return {
            props,
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
        }
    },
}
</script>
